// extracted by mini-css-extract-plugin
module.exports = {"comment":"Comment_comment__2fhXC"};